export default {
  title: 'Trouver des illustrations scientifiques',
  subTitle: "La plus grande galerie d'illustrations scientifiques au monde!",
  label: 'Recherchez parmi nos 75 000+ illustrations',
};
